module.exports = __webpack_public_path__ + "static/media/workano-light-fa.e19f4919.svg";